export default "__VITE_PUBLIC_ASSET__7baaf874__"